
<div cdkDrag class="note-personali-box" style="resize: horizontal;overflow:auto;min-width:20%;"  cdkDragBoundary=".example-boundary" >
    <div cdkDragHandle style="cursor:all-scroll;line-height: 15px;" >
        <!-- <svg width="24px" fill="currentColor" viewBox="0 0 24 24" style="cursor:pointer;color:rgb(117, 116, 116)"> -->
        <svg width="0" viewBox="0 0 24 24" >
            <path 
                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
            </path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
         <!-- <mat-icon class="chiudiModale" (click)="onClose()">highlight_off</mat-icon> --> 
    </div>
    <div style="display: flex;">
        <app-custom-editor  style="flex-grow: 0;" [editorId]="loggedUserId" tipoEditor="note-personali" [content]="note"
            (saving)="onSaveContent($event)" (closing)="onClose()"></app-custom-editor>
    </div>
</div>
